import { FullscreenOutlined } from "@ant-design/icons";
import { useSearch } from "@tanstack/react-router";
import { Button } from "antd";
import { useGetCascadeQuery } from "api/TenantSlug/Cascade/hooks.ts";
import {
    SimpleCommissionsTableContainer
} from "components/Tables/SimpleCommissionsTable/SimpleCommissionsTableContainer.tsx";
import { Drawer } from "components/UI/Drawer";
import { DrawerContent } from "components/UI/DrawerContent/DrawerContent.tsx";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useRef } from "react";
import { PermissionEnum } from "types/enums.ts";
import { DrawerId } from "types/models.ts";
import { getDrawerSearchParams } from "utils/drawerHelpers";

interface SearchParams {
    [`cascadeCommissions-id`]: string;
}

export const CascadeCommissionsDrawer = () => {
    const drawerId = DrawerId.CascadeCommissions;
    const searchParams = useSearch({ strict: false }) as SearchParams;
    const cascadeId = searchParams[`${drawerId}-id`];
    const { t } = usePaldockTranslation("drawers.cascade-commissions");
    const { t: tC } = usePaldockTranslation("common");
    const expandButtonRef = useRef<() => void>(null);

    const getCascadeQuery = useGetCascadeQuery(
        cascadeId,
        {
            filter: {
                include: "commissions",
            },
        },
        {
            enabled: !!cascadeId,
        }
    );

    const cascade = getCascadeQuery.data?.cascade;

    if (!cascade || !cascadeId) {
        return null;
    }

    return (
        <Drawer
            drawerId={drawerId}
            title={<DrawerTitle mainTitle={t("title", { name: cascade.title })} />}
            searchParamsToClean={getDrawerSearchParams(drawerId, "id")}
            styles={{
                body: { padding: 0 },
            }}
            extraButtons={
                <Button onClick={() => expandButtonRef.current?.()} size="large" icon={<FullscreenOutlined />}>
                    {tC("expand")}
                </Button>
            }
        >
            <DrawerContent className={"m-[24px]"}>
                <div className={"p-[16px]"}>
                    <SimpleCommissionsTableContainer cascade={cascade} editPermission={PermissionEnum.AffiliateCommissionCurrentTierEdit} expandButtonRef={expandButtonRef} />
                </div>
            </DrawerContent>
        </Drawer>
    );
};
